export async function postData(url, formData, csrfToken) {
  try {
    const bodyData = { ...formData, [csrfToken.csrfTokenName]: csrfToken.csrfTokenValue };
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      ...(bodyData ? { body: JSON.stringify(bodyData) } : {}),
    });
    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
}
